// scroll-keep.js — Scroll-Position einer Liste über das Neuladen der Seite halten (2026-10-25, Nutzerwunsch).
// Gemerkt je Liste und Filter in sessionStorage (gilt für diesen Tab, verfällt mit ihm). Was scrollt, entscheidet
// das Layout: am Desktop die Spalte (overflow auto), am Handy das Fenster. Ist die Liste ausgeblendet (Handy mit
// offenem Detail), wird nichts gespeichert — dann gehört das Fenster-Scrollen dem Detail.

const PREFIX = 'vc-scroll:';

/** Scrollt das Element selbst, oder die Seite? */
export function scrollerOf(el) {
  const cs = getComputedStyle(el);
  return /(auto|scroll)/.test(cs.overflowY) && el.scrollHeight > el.clientHeight ? el : null;
}
const visible = (el) => el.isConnected && el.getClientRects().length > 0;

function read(key) {
  try { const v = JSON.parse(sessionStorage.getItem(PREFIX + key) || 'null'); return v && Number.isFinite(v.y) ? v : null; } catch { return null; }
}
function write(key, v) { try { sessionStorage.setItem(PREFIX + key, JSON.stringify(v)); } catch { /* privat/voll: dann eben nicht */ } }

/**
 * el = Listenbereich, key() = Schlüssel der aktuellen Ansicht (Liste + Filter).
 * Ergebnis: { restore() — einmal nach dem ersten Zeichnen mit Daten, off() }.
 */
export function keepScroll(el, key) {
  let raf = 0, restored = false;
  const save = () => {
    raf = 0;
    // vor dem Wiederherstellen steht die Liste oben — das darf die gemerkte Position nicht überschreiben
    if (!restored || !visible(el)) return;
    const s = scrollerOf(el);
    write(key(), { y: s ? s.scrollTop : window.scrollY, pane: !!s });
  };
  const onScroll = () => { if (!raf) raf = requestAnimationFrame(save); };
  el.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('pagehide', save);
  return {
    el,
    restore() {
      if (restored) return;
      restored = true;
      const v = read(key());
      if (!v || !v.y || !visible(el)) return;
      // nach dem Layout setzen; das Zielelement wird ohne Animation positioniert
      requestAnimationFrame(() => {
        const s = scrollerOf(el);
        if (s) s.scrollTo({ top: v.y, behavior: 'instant' });
        else window.scrollTo({ top: v.y, behavior: 'instant' });
      });
    },
    off() {
      if (raf) cancelAnimationFrame(raf);
      save();
      el.removeEventListener('scroll', onScroll);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('pagehide', save);
    },
  };
}
